import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import configureStore from "./store";

import App from "./components/App";
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from "./registerServiceWorker";

const preloadedState = window.__PRELOADED_STATE__ ? window.__PRELOADED_STATE__ : {};
// console.log('window.__PRELOADED_STATE__', window.__PRELOADED_STATE__)
delete window.__PRELOADED_STATE__;

const Store = configureStore(preloadedState);

const rootEl = document.getElementById("root");

const renderMethod = !!module.hot ? ReactDOM.render : ReactDOM.hydrate;
renderMethod(
	<Provider store={Store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>,
	rootEl
);

if (module.hot) {
	module.hot.accept("./components/App", () => {
		ReactDOM.hydrate(
			<Provider store={Store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>,
			rootEl
		);
	});
}

// registerServiceWorker()
unregister();



// WEBPACK FOOTER //
// ./src/index.js